import { render, staticRenderFns } from "./fields-group.vue?vue&type=template&id=56004e36&scoped=true&"
import script from "./fields-group.vue?vue&type=script&lang=js&"
export * from "./fields-group.vue?vue&type=script&lang=js&"
import style0 from "./fields-group.vue?vue&type=style&index=0&id=56004e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56004e36",
  null
  
)

export default component.exports